import { render, staticRenderFns } from "./ListTipoAtendimento.vue?vue&type=template&id=ca2d6a02"
import script from "./ListTipoAtendimento.vue?vue&type=script&lang=js"
export * from "./ListTipoAtendimento.vue?vue&type=script&lang=js"
import style0 from "./ListTipoAtendimento.vue?vue&type=style&index=0&id=ca2d6a02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports